import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { Navigate as navigate } from 'react-big-calendar'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Tooltip from '@mui/material/Tooltip';

class CustomToolbar extends React.Component {
  render() {
    let {
      localizer: { messages },
      label,
    } = this.props

    return (
      <div className="rbc-toolbar" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.TODAY)}
          >
            {messages.today}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            {messages.previous}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            {messages.next}
          </button>
        </span>

        <span 
          className="rbc-toolbar-label-group" 
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center', width: '260px' }}
        >
          {this.props.view === 'agenda' && (
            <Tooltip title={`Go to ${this.props.prevAgendaView(false)}`} arrow>
              <ChevronLeftIcon
                onClick={() => this.props.prevAgendaView(true)}
                style={{ cursor: 'pointer' }}
                size="small"
              />
            </Tooltip>
          )}
          <span 
            className="rbc-toolbar-label" 
            style={{ flexGrow: 1, textAlign: 'center', fontSize: '1.1rem', fontWeight: '500' }}
          >
            {label}
          </span>
          {this.props.view === 'agenda' && (
            <Tooltip title={`Go to ${this.props.nextAgendaView(false)}`} arrow>
              <ChevronRightIcon
                onClick={() => this.props.nextAgendaView(true)}
                style={{ cursor: 'pointer' }}
                size="small"
              />
            </Tooltip>
          )}
        </span>

        <span className="rbc-btn-group">{this.viewNamesGroup(messages)}</span>
      </div>
    )
  }

  navigate = (action) => {
    this.props.onNavigate(action)
  }

  view = (view) => {
    this.props.onView(view)
  }

  viewNamesGroup(messages) {
    let viewNames = this.props.views
    const view = this.props.view

    if (viewNames.length > 1) {
      return viewNames.map((name) => (
        <button
          type="button"
          key={name}
          className={clsx({ 'rbc-active': view === name })}
          onClick={this.view.bind(null, name)}
        >
          {messages[name]}
        </button>
      ))
    }
  }
}

CustomToolbar.propTypes = {
  view: PropTypes.string.isRequired,
  views: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.node.isRequired,
  localizer: PropTypes.object,
  onNavigate: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  prevAgendaView: PropTypes.func.isRequired, // Added prop type
  nextAgendaView: PropTypes.func.isRequired, // Added prop type
}

export default CustomToolbar